import { Component, OnInit, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { Profissional } from 'src/app/admihair/api/dto/profissional';
import { ProfissionalHabilidade } from 'src/app/admihair/api/dto/profissional-habilidade';
import { ProfissionalHabilidadeService } from 'src/app/admihair/service/profissional-habilidade.service';
import { ProfissionalService } from 'src/app/admihair/service/profissional.service';
import { AdmihairBaseComponent } from '../../../admihair-base.component';
import { ErroService } from 'src/app/admihair/service/erro.service';
import { UtilStorageService } from 'src/app/admihair/service/util-storage.service';

@Component({
  selector: 'app-profissional-detalhar',
  templateUrl: './profissional-detalhar.component.html',
  styleUrls: ['./profissional-detalhar.component.scss']
})
export class ProfissionalDetalharComponent extends AdmihairBaseComponent implements OnInit {


  @ViewChild('f') form?: NgForm;
  id?: number;
  loadingProfissional: boolean = true;
  profissional?: Profissional;
  habilidades: ProfissionalHabilidade[] = [];

  constructor(private activatedRouter: ActivatedRoute,
    private profissionalService: ProfissionalService,
    private profissionalHabilidadeService: ProfissionalHabilidadeService,
    erroService: ErroService,
    storageService: UtilStorageService) {
    super(erroService, storageService)
  }


  ngOnInit(): void {
    this.permissaoDetalhar = this.verificarPermissao('PERM_DETALHAR_PROFISSIONAL');
    this.carregarIdProfissional();
    if (this.permissaoDetalhar) {
      this.carregarProfissional();
    }
  }

  carregarProfissional() {
    this.profissionalService.buscarPorId(this.id).subscribe({
      next: (data: Profissional) => {
        this.profissional = data;
        this.listarProfissionaisHabilidadesPorId();
      },
      error: (err: any) => {
        this.loadingProfissional = false;
        this.exibirMensagemErro(err);
      }
    });
  }

  listarProfissionaisHabilidadesPorId() {
    this.profissionalHabilidadeService.listarPorProfissionalId(this.profissional?.id).subscribe({
      next: (data: ProfissionalHabilidade[]) => {
        this.habilidades = data;
        this.loadingProfissional = false;
      },
      error: (err: any) => {
        this.loadingProfissional = false;
        this.exibirMensagemErro(err);
      }
    })
  }

  carregarIdProfissional() {
    const idParam = this.activatedRouter.snapshot.paramMap.get('id');
    if (idParam) {
      this.id = parseInt(idParam);
    }
  }

}
